import React, { Suspense, useEffect, useRef, useState } from 'react';

import { Accordion } from 'js/app/components/common/Accordion';
import { AccordionItem } from 'js/app/components/common/Accordion/components/AccordionItem';

import { dispatcher } from 'dispatcher';
import { clsx } from 'js/app/utils/clsx.util';
import { ADMIN_RESERVE_BLOCK } from 'js/app/components/system/Portal/constants';

export const BlockForPortletsWithoutPlace = () => {
    const reserveBlockRef = useRef();
    const [isHidden, setIsHidden] = useState(true);

    useEffect(() => {
        dispatcher.dispatch('portalPlace:update', ADMIN_RESERVE_BLOCK);

        return () => {
            dispatcher.dispatch('portalPlace:update', ADMIN_RESERVE_BLOCK);
        };
    }, []);

    useEffect(() => {
        if (!reserveBlockRef.current) {
            return;
        }

        setIsHidden(!reserveBlockRef.current?.children.length);

        const observer = new MutationObserver(() => {
            setIsHidden(!reserveBlockRef.current?.children.length);
        });

        observer.observe(reserveBlockRef.current, { childList: true });

        return () => {
            observer.disconnect();
        };
    }, [reserveBlockRef]);

    return (
        <div
            data-column-id={`column-${1}`} id={`column-${1}`}
            className={clsx({ hidden: isHidden })}
        >
            <div className="portlet-dropzone">
                <Suspense fallback="">
                    <Accordion className="portlet-wrapper">
                        <AccordionItem isForcedInDesktop title="Block For Portlets Without Place">
                            <div id={ADMIN_RESERVE_BLOCK} ref={reserveBlockRef} />
                        </AccordionItem>
                    </Accordion>
                </Suspense>
            </div>
        </div>
    );
};
